import type {ErrorComponentProps} from "@tanstack/react-router";
import {NonEmbeddedErrorComponent} from "~/components/routerHelpers/nonEmbeddedErrorComponent";
import {Route} from "./__root";

export function ErrorComponent({error, info, reset}: ErrorComponentProps) {
    return (
        <NonEmbeddedErrorComponent
            error={error}
            info={info}
            reset={reset}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            route={Route as any}
            //
        />
    );
}
